import { initHeroesFromJson, getRandomHeroesByFaction } from './heroesHelper';
const DuelController = function(dataStore) {
  let currentGameState = null;
  let gameData = {};
  let allHeroesSet = {};

  let states = {
    '0_INIT': new initState(this),
    '1_SELECT_FACTION': new selectFactionState(this)
  };

  let setCurrentState = (stateName, payload = null) => {
    currentGameState = states[stateName];
    gameData.gameState = stateName;
    currentGameState.start(payload);
  };
  let updateCurrentState = (payload = null) => {
    currentGameState.update(payload);
  };

  let storeData = () => {
    return dataStore.save(gameData);
  };
  let loadData = () => {
    gameData = dataStore.load();
  };

  let startNewGame = function(
    player1Name,
    player2Name,
    allHeroesJson,
    gameOptions
  ) {
    allHeroesSet = initHeroesFromJson(allHeroesJson);
    setCurrentState('0_INIT', {
      player1Name,
      player2Name,
      gameOptions
    });
    updateCurrentState();
  };
  let resumeGame = function() {};

  let DuelControllerProxy = () => {
    return {
      endTurn: data => {
        currentGameState.update(data);
      }
    };
  };
  return {
    startNewGame,
    resumeGame,
    duelControllerProxy: new DuelControllerProxy(),
    storeData,
    loadData,
    setCurrentState,
    updateCurrentState,
    gameData,
    allHeroesSet
  };
};

let initState = function(duelCtrl) {
  let start = function(payload = null) {
    duelCtrl.gameData = {
      playerBlue: {
        name: payload.player1Name
      },
      playerRed: {
        name: payload.player2Name
      },
      gameOptions: payload.gameOptions,
      waitingForBlue: false,
      waitingForRed: false,
      currentPlayer: ''
    };
  };
  let update = function(payload = null) {
    duelCtrl
      .storeData()
      .then(() => {
        switch (duelCtrl.gameData.gameOptions.deck) {
          case 'faction':
            duelCtrl.setCurrentState('1_SELECT_FACTION');
            break;
          case 'tournament':
            break;

          case 'draft':
            break;

          default:
            break;
        }
      })
      .catch(err => {
        console.log('Error storing data ', err);
        // Retry in 5 sec
        setTimeout(() => {
          duelCtrl.updateCurrentState();
        }, 5000);
      });
  };
  return {
    start,
    update
  };
};
let selectFactionState = function(duelCtrl) {
  let start = function(payload = null) {
    duelCtrl.gameData.heroesToSelect = duelCtrl.allHeroesSet;
    duelCtrl.gameData.waitingForBlue = true;
    duelCtrl.gameData.waitingForRed = true;
    duelCtrl.gameData.currentPlayer = 'both';
    duelCtrl.storeData
      .then(() => {
        console.log('Wating for both players');
      })
      .catch(err => {
        console.log('Error storing data ', err);
        // Retry in 5 sec
        setTimeout(() => {
          duelCtrl.currentGameState.start();
        }, 5000);
      });
  };

  let update = function(payload = null) {
    if (payload) {
      let player = 'player' + payload.player;
      duelCtrl.gameData[player].faction = payload.faction;
      duelCtrl.gameData[player].twelveHeroes = getRandomHeroesByFaction(
        payload.faction
      );
      duelCtrl.gameData['waitingFor' + payload.player] = false;
    }

    if (
      duelCtrl.gameData.waitingForBlue === false &&
      duelCtrl.gameData.waitingForRed === false
    ) {
      duelCtrl.storeData
        .then(() => {
          console.log('Going to next STATE');
        })
        .catch(err => {
          console.log('Error storing data ', err);
          // Retry in 5 sec
          setTimeout(() => {
            duelCtrl.currentGameState.update();
          }, 5000);
        });
    }
  };

  return {
    start,
    update
  };
};

export default DuelController;
